import React, { useEffect, useMemo } from "react";
import Select from "react-select";
import { getPRMCodeOptions } from "_utils";

// redux
import { useSelector } from "react-redux";
import { selectUserDb } from '_redux/slices/main-screen/user';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

const AssistanceSelector = (props) => {


  // redux
  const userDb = useSelector(selectUserDb);
  const usedTheme = useSelector(selectUsedTheme);
  const isBooking = props.isBooking;

  // Selectable codes are derived from the single source of truth (constants.PRMCodes),
  // gated by the logged-in airport authority (e.g. LNYD only for DUB, PETC only for BFS).
  const authority = userDb?.details?.authority;
  const codes = useMemo(() => getPRMCodeOptions(authority), [authority]);

  useEffect(() => {
    props.setAssistance(props.value);
  }, []);

  const transformToObject = (value) => {
    if (!value) { return [] }
    let result = []

    // check if airport logged in is dublin
    if (Array.isArray(value) && value.length > 0) {
      value?.forEach((element) => {
        if (element) {
          element = element.replace(/\s/g, "")
          const matchingCode = codes.find(code => code.value == element);
          result.push(matchingCode || { label: element, value: element })
        }
      });
    }
    return result;
  };

  const handleChange = (selection) => {
    let assistanceList = [];
    for (let index = 0; index < selection.length; index++) {
      assistanceList.push(selection[index].value);
    }
    props.setAssistance(assistanceList);
  };

  return (
    <Select
      isMulti
      name="assistance"
      options={codes}
      className="basic-multi-select"
      classNamePrefix="select"
      onChange={(selection) => {
        handleChange(selection);
      }}
      value={transformToObject(props.value)}
      menuPortalTarget={document.body}
      menuPlacement="auto"
      menuPosition="fixed"
      styles={{
        control: (provided) => ({
          ...provided,
          minWidth: "25%",
          borderRadius: "5px",
          backgroundColor: isBooking ? 'white' : usedTheme.BACKGROUND_COLOR,
          borderColor: isBooking ? '#ddd' : usedTheme.BORDER_COLOR,
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR,
        }),
        placeholder: (provided) => ({
          ...provided,
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR,
        }),
        singleValue: (provided) => ({
          ...provided,
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR,
          backgroundColor: isBooking ? 'white' : usedTheme.BACKGROUND_COLOR,
        }),
        menu: (provided) => ({
          ...provided,
          backgroundColor: isBooking ? 'white' : usedTheme.BACKGROUND_COLOR,
          borderColor: isBooking ? '#ddd' : usedTheme.BORDER_COLOR,
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR
        }),
        menuPortal: (provided) => ({
          ...provided,
          zIndex: 9999
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: isBooking
            ? (state.isFocused ? '#ddd' : 'white')
            : (state.isFocused ? usedTheme.BORDER_COLOR : usedTheme.BACKGROUND_COLOR),
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR,
          cursor: 'pointer',
        }),
        multiValue: (provided) => ({
          ...provided,
          backgroundColor: isBooking ? 'white' : usedTheme.BACKGROUND_COLOR,
        }),
        multiValueLabel: (provided) => ({
          ...provided,
          color: isBooking ? 'black' : usedTheme.TEXT_COLOR,
        }),
      }}
    />
  );
};

export default AssistanceSelector;
